@if (imagesList().length) {
<div class="image-viewer-wrapper">
  <!-- Preview Image -->
  <owl-carousel-o
    [options]="customOptionsSingleImage"
    #previewCarousel
    (translated)="setCarouselStartPosition()"
    (dragging)="isDragging = $event.dragging"
  >
    @for (image of images(); track image; let i = $index) {
    <ng-template [id]="i + ''" carouselSlide>
      <div class="display-image-container">
        <picture>
          <img class="display-image" [src]="image.image" />
        </picture>
      </div>
    </ng-template>
    }
  </owl-carousel-o>

  <!-- navigation button -->

  <!-- Previous -->
  <button
    [disabled]="$any(previewCarousel)?.slidesOutputData?.startPosition === 0"
    [class.btn-disabled]="$any(previewCarousel)?.slidesOutputData?.startPosition === 0"
    class="prev-btn"
    type="button"
    (click)="previous()"
  >
    <img [src]="IMAGE_URLS.leftNavIcon" class="navigation-icon" />
  </button>

  <!-- Next -->
  <button
    [disabled]="previewCarousel?.slidesOutputData?.startPosition === imagesList().length - 1"
    [class.btn-disabled]="
      previewCarousel?.slidesOutputData?.startPosition === imagesList().length - 1
    "
    class="next-btn"
    type="button"
    (click)="next()"
  >
    <img [src]="IMAGE_URLS.rightNavIcon" class="navigation-icon" />
  </button>
</div>
} @else {
<!-- for no Preview Image state -->
<div class="image-viewer-wrapper">
  <div class="image-container">
    <img [src]="IMAGE_URLS.noImagePlaceholder" class="display-image" />
  </div>
</div>
}
